export default __webpack_public_path__ + "static/media/governor_book_header.f21b9d0c.png";